import 'jquery';
import 'tether';
import 'bootstrap';
import 'widgster';
import 'bootstrap-select';
import 'select2';
// import 'pace-js'
import 'ng2-daterangepicker';
//import 'select2/dist/js/select2.full.js';

import 'jquery-sparkline';

if ('production' === ENV) {
  // Production


} else {
  // Development

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/vendor.browser.ts